import { Module } from 'vuex';
import { EmoticonEntity } from '@/entities/emoticon.entity';
import { CheeersRootState } from '@/store';
import { service } from '@/services/service';
import EmoticonService from '@/services/emoticon.service';

export interface EmoticonState {
  emoticons: EmoticonEntity[];
}

export const emoticon: Module<EmoticonState, CheeersRootState> = {
  namespaced: true,

  state: (): EmoticonState => ({
    emoticons: [],
  }),

  getters: {
    emoticons: (state): EmoticonEntity[] => state.emoticons,
  },

  mutations: {
    SET_EMOTICONS: (state, emoticons: EmoticonEntity[]) => {
      state.emoticons = emoticons;
    },
  },

  actions: {
    async fetchEmoticons({ commit }) {
      const emoticonService = service(EmoticonService);
      const emoticons = await emoticonService.getMany();
      commit('SET_EMOTICONS', emoticons);
    },
  },
};

export default emoticon;
